import {
  call, put, takeLeading, select,
} from 'redux-saga/effects';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { EDIT_TRANSLATIONS_REQUEST } from '../actions/types/MrdAppTranslationsActionsTypes';
import {
  editTranslationsFailureActionCreator,
  editTranslationsSuccessActionCreator,
} from '../actions/MrdAppTranslationsActions';
import { apiEditTranslations } from '../../api/MrdAppTranslationsAPI';

function* editTranslationsWorker(action) {
  const lang = yield select(languageSelector);
  try {
    yield call(apiEditTranslations, action.payload);
    yield put(editTranslationsSuccessActionCreator());
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.translations.edit.success'),
    }));
  } catch (error) {
    yield put(editTranslationsFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.translations.edit.failure'),
    }));
  }
}

function* translationsWatcher() {
  yield takeLeading(EDIT_TRANSLATIONS_REQUEST, editTranslationsWorker);
}

export default translationsWatcher;
export {
  editTranslationsWorker,
};
